var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form popup-cloud"
  }, [_c('div', {
    staticClass: "content-form-popup noselect"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" Nahranie súboru ")])]), _c('div', [_vm.fileNameMissing ? _c('p', {
    staticClass: "clientError"
  }, [_vm._v("Zadajte prosím názov súboru")]) : _vm._e(), _vm.uploadError ? _c('p', {
    staticClass: "clientError"
  }, [_vm._v(_vm._s(_vm.uploadError))]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fileName,
      expression: "fileName"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "128",
      "name": "hodnota-nehnutelnosti",
      "id": "hodnota-nehnutelnosti",
      "required": ""
    },
    domProps: {
      "value": _vm.fileName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.fileName = $event.target.value;
      }
    }
  })]), _vm._l(_vm.files, function (fileObject, index) {
    var _fileObject$file;
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "add-file-wrapper mt-2 p-relative"
    }, [_c('label', {
      staticClass: "sub-ctass image-upload-btn add-file-button pointer blc-color pop-500",
      attrs: {
        "for": 'file-upload' + index
      }
    }, [_vm._v(" " + _vm._s(fileObject !== null && fileObject !== void 0 && (_fileObject$file = fileObject.file) !== null && _fileObject$file !== void 0 && _fileObject$file.name ? fileObject.file.name : "Fotka / Sken " + (index + 1)) + " "), fileObject.file ? _c('img', {
      staticClass: "nav-link-icon extrasmall filter-primary MGleft10px",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f50_icons8-done.svg",
        "alt": ""
      }
    }) : _vm._e(), _c('input', {
      attrs: {
        "id": 'file-upload' + index,
        "type": "file",
        "accept": _vm.extra ? _vm.extra : '.pdf,.xlsx,.png,.jpg,.jpeg,.docx,.doc,.zip,.asice'
      },
      on: {
        "change": function change($event) {
          return _vm.handleFiles(index);
        }
      }
    })]), index > 0 ? _c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.files.splice(index, 1);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]) : _vm._e()]), fileObject.encrypted ? _c('div', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": fileObject.file.name
      }
    }, [_vm._v(" Zadajte heslo: ")]), _c('div', {
      staticClass: "input-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: fileObject.password,
        expression: "fileObject.password"
      }],
      staticClass: "text-input w-input date-input",
      attrs: {
        "type": "text",
        "name": fileObject.file.name,
        "id": fileObject.file.name
      },
      domProps: {
        "value": fileObject.password
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(fileObject, "password", $event.target.value);
        }
      }
    }), _c('div', {
      staticClass: "input-float-button"
    }, [_c('span', {
      staticClass: "pop-600 bl-color font-size-12 pointer noselect",
      on: {
        "click": function click($event) {
          return _vm.submitUnlockPdf(fileObject.password, fileObject.file, index);
        }
      }
    }, [_vm._v(" Odomoknúť ")])])])]) : _vm._e()]);
  }), !_vm.fileWord && !_vm.fileZip && !_vm.fileExcel && !_vm.fileAsice ? _c('div', {
    staticClass: "text-cta d-flex center MGtop20px",
    "class": {
      'locked-add': _vm.lockedPassword
    },
    on: {
      "click": _vm.addNewFile
    }
  }, [_vm._v(" + PRIDAŤ STRANU ")]) : _vm._e()], 2)]), _c('div', {
    staticClass: "information-wrapper"
  }, [_c('span', {
    staticClass: "blc-color"
  }, [_vm._v("Dokument môžete nahrať pomocou viacerých fotiek alebo PDF súborov; po uložení sa automaticky zlúčia do jedného. Maximálna veľkosť je 25 MB.")]), _c('div', [_vm.loading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('button', {
    staticClass: "w-button",
    "class": {
      'locked-add': _vm.lockedPassword
    },
    on: {
      "click": _vm.transformFiles
    }
  }, [_vm._v(" Uložiť a odoslať ")])], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "hodnota-nehnutelnosti"
    }
  }, [_vm._v("Názov súboru"), _c('strong')]);

}]

export { render, staticRenderFns }